var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39.997 39.997"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  "data-name": "Rectangle 24560"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m27.946 3.334.982.969-15.9 15.691 15.9 15.7-.982.973-16.878-16.672Z",
  "data-name": "Path 5630"
})));
export { SvgChevronLeft as ReactComponent };
export default "/_next/static/images/chevron-left.svg";